export default __webpack_public_path__ + "locales/fr/Ldap.json?hash=4ae45d9fb9d2b174aae01ba91a92a5e3";